// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"7e8a639a","453":"eccbf8d8"}[chunkId] + ".chunk.js";
};